import { Box, Button, Dialog, DialogContent, Paper, Typography } from "@mui/material";
import { initPageData, jobOrderApiNm } from 'constants/jobOrderConstant';
import { blueGrey } from "@mui/material/colors";
import { BoxFC, BoxFR } from "components/BoxCustom";
import PaperComponent from "components/PaperComponent";
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import React, { useCallback, useContext, useEffect, useState } from "react";
import ContStatus from "./DailyJobDialogV2Component/ContStatus";
import Shipment from "./DailyJobDialogV2Component/Shipment";
import Shore from "./DailyJobDialogV2Component/Shore";
import Memo from "./DailyJobDialogV2Component/Memo";
import dayjs from "dayjs";
import { printJobOrder } from "branch/functions/printJobOrder";
import { UserContext } from "contexts/UserContext";
import ButtonGroupPopper from "components/ButtonGroupPopper";
import { alertConfirmDelete, alertError } from "components/Alert";
import { checkContStatus } from "./DailyJobDialogV2Component/checkContStatus";
import { addIdForDataGrid } from "utils";
import XJOComponent from "./DailyJobDialogV4Component/XJOComponent";
import PCComponent from "./DailyJobDialogV4Component/PCComponent";
import ContStsComponent from "./DailyJobDialogV4Component/ContStsComponent";
import JODataComponent from "./DailyJobDialogV4Component/JODataComponent";
import FilePreviewComponent from "./DailyJobDialogV4Component/FilePreviewComponent";
import JODataExtraComponent from "./DailyJobDialogV4Component/JODataExtraComponent";
// import PettyCash from "./DailyJobDialogV2Component/PettyCash";

let prevContStsData = []
let oContStatusData = []
let oJOData = {}
let oTagData = []
let oMemoData = []

const DailyJobDialogV3 = ({ selectedId, dialogOpen, setDialogOpen, lastFilter, onFinish }) => {

  const { ax, msData, setTargetTimestamp } = useContext(GlobalStateContext)
  const { user } = useContext(UserContext)

  const [contStatusData, setContStsData] = useState([])
  const [joData, setJOData] = useState({ ...initPageData })
  const [tagData, setTagData] = useState([])
  const [memoData, setMemoData] = useState([])
  const [ptDataTable, setPTDataTable] = useState([])
  const [piDataTable, setPIDataTable] = useState([])
  const [xjoDataTable, setXJODataTable] = useState([])
  const [filesData, setFilesData] = useState([])

  const deleteJobOrder = useCallback((jobOrdId) => {
    alertConfirmDelete(() => {
      ax.post(jobOrderApiNm.deleteJobOrder, { JobOrdId: jobOrdId }).then(value => {
        if (value.data) {
          // processConstStatus(value.data, msData)
          //setDataTable(addIdForDataGrid(value.data, "JobOrdId"));
          setDialogOpen(false);
          setTargetTimestamp(dayjs())
          onFinish()
        }
      })
    })
  }, [ax, setTargetTimestamp, onFinish, setDialogOpen])

  const handleDialogOK = useCallback(async () => {
    //set joData back to init data

    if (!joData.AptTm) {
      alertError("วันที่นัดส่ง ต้องไม่เป็นค่าว่าง")
      return
    }



    const contStsHasChange = JSON.stringify(oContStatusData) !== JSON.stringify(contStatusData)
    const tagDataHasChange = JSON.stringify(oTagData) !== JSON.stringify(tagData)
    const joDataHasChange = JSON.stringify(oJOData) !== JSON.stringify(joData)
    const memoDataHasChange = JSON.stringify(oMemoData) !== JSON.stringify(memoData)
    let ptDataHasChange = false


    const postData = {
      getArgs: lastFilter
    }

    const foundPCTrns = ptDataTable.filter(pt => pt.TmpUsrAccId)
    if (joData.processDrvId && foundPCTrns.length > 0) {
      ptDataHasChange = true
      postData.ptData = {
        UsrAccId: joData.processDrvId,
        PCTrnsIds: foundPCTrns.map(pt => pt.PCTrnsId)
      }
    }

    joData.processDrvId = null

    if (contStsHasChange) {
      postData.contStatusData = contStatusData
    }

    if (tagDataHasChange) {
      // await ax.post(jobOrderApiNm.updateJobOrderTag, { JobOrdIds: [selectedId], TagIds: tagData.map(tag => tag.id) })
      postData.tagData = { JobOrdIds: [selectedId], TagIds: tagData.map(tag => tag.id) }
    }

    const joColValue = {}
    if (joDataHasChange) {
      for (const key in joData) {
        if (oJOData[key] !== joData[key]) {
          joColValue[key] = joData[key]
        }
      }
      postData.jobOrdData = {
        JobOrdId: joData.JobOrdId,
        ColValues: joColValue,
        LogRmk: "แก้ไขข้อมูลใบงาน"
      }
    }
    if (memoDataHasChange) {
      const memoText = memoData && memoData.length > 0 ?
        JSON.stringify(memoData.map(memo => ({
          IsPin: memo.IsPin,
          Memo: memo.Memo,
          MemTm: dayjs(memo.MemTm).format("YYYY-MM-DD HH:mm:ss"),
          ModAccId: memo.ModAccId,
        })))
        : null
      if (postData.jobOrdData) {

        postData.jobOrdData.ColValue = {
          ...postData.jobOrdData.ColValue,
          Memo: memoText
        }
      } else {
        postData.jobOrdData = {
          JobOrdId: joData.JobOrdId,
          ColValues: { Memo: memoText },
          LogRmk: "แก้ไข Memo"
        }
      }
    }

    if (contStsHasChange || tagDataHasChange || joDataHasChange || memoDataHasChange || ptDataHasChange) {

      ax.post(jobOrderApiNm.updateJobOrderAllDetailV4, postData).then(value => {
        if (value.data) {
          onFinish && onFinish(value.data)
        }
      })
    }
    setDialogOpen(false)

  }, [joData, contStatusData, tagData, ax, lastFilter, memoData, onFinish, selectedId, setDialogOpen, ptDataTable])

  const handlePrintJobOrder = useCallback(() => {

    joData.ContStses = contStatusData.map(cs => ({ ...cs, ContStsNm: msData.containerStatusObj[cs.ContStsId].Name }))
    printJobOrder({
      printDataArr: [{
        jobOrderData: joData, shipmentData: joData.Shipment, jobOrdIds: [joData.JobOrdId],
        fName: user.FName
      }], msData
    })
  }, [joData, msData, user.FName, contStatusData])

  const handlePrintJobOrderWithBg = useCallback(() => {

    joData.ContStses = contStatusData.map(cs => ({ ...cs, ContStsNm: msData.containerStatusObj[cs.ContStsId].Name }))
    printJobOrder({
      printDataArr: [{
        jobOrderData: joData, shipmentData: joData.Shipment, jobOrdIds: [joData.JobOrdId],
        fName: user.FName
      }],
      msData,
      withBackground: true
    })
  }, [joData, msData, user.FName, contStatusData])

  const onPettyCashFinish = useCallback(() => {
    ax.post(jobOrderApiNm.getDailyJobAllDetailV4Finance, { JobOrdId: selectedId }).then(value => {
      if (value.data) {
        setPTDataTable(addIdForDataGrid(value.data.PTs, "PCTrnsId"))
        setPIDataTable(addIdForDataGrid(value.data.PIs, "PCItmId"))
        setXJODataTable(addIdForDataGrid(value.data.XJOs, "ExpJobOrdId"))
        setFilesData(value.data.Files || [])
      }
    })
  }, [ax, selectedId])


  useEffect(() => {
    const prevSts2DrvId = prevContStsData.find(cs => cs.ContStsId === 2)?.DrvId || null
    const prevSts4DrvId = prevContStsData.find(cs => cs.ContStsId === 4)?.DrvId || null
    const currSts2DrvId = contStatusData.find(cs => cs.ContStsId === 2)?.DrvId || null
    const currSts4DrvId = contStatusData.find(cs => cs.ContStsId === 4)?.DrvId || null
    if (prevSts2DrvId !== currSts2DrvId) {
      if (!currSts2DrvId) {
        setJOData(o => ({ ...o, Sts2POIId: null }))
        return
      }
      const poiid = msData.serverData.CompanyData.Sts2POIId
      if (poiid) {
        setJOData(o => ({ ...o, Sts2POIId: poiid }))
      }
    }
    if (prevSts4DrvId !== currSts4DrvId) {
      if (!currSts4DrvId) {
        setJOData(o => ({ ...o, Sts4POIId: null }))
        return
      }
      const poiid = msData.serverData.CompanyData.Sts4POIId
      if (poiid) {
        setJOData(o => ({ ...o, Sts4POIId: poiid }))
      }
    }
  }, [contStatusData, msData.serverData.CompanyData])

  useEffect(() => {
    checkContStatus({ contStatusData, joData, prevContStsData })
  }, [contStatusData, joData])

  useEffect(() => {
    if (dialogOpen) {
      ax.post(jobOrderApiNm.getDailyJobAllDetailV4, { JobOrdId: selectedId }).then(value => {
        if (value.data) {
          const contStses = value.data.ContStses
          oContStatusData = msData.containerStatuses.filter(item => !item.IsHide).map(contStatus => {
            const foundData = contStses?.find(it => it.ContStsId === contStatus.ContStsId)
            return {
              ...contStatus,
              DrvId: foundData && foundData.DrvId,
              TukId: foundData && foundData.TukId,
              JobOrdId: selectedId,
              StsTm: foundData && foundData.StsTm,
              Rmk: foundData && foundData.Rmk,
              IsCmpt: foundData && foundData.IsCmpt
            }
          })
          oTagData = value.data.Tags.map(item => ({ id: item.TagId, label: item.Name }))

          !value.data.Memo && (value.data.Memo = [])
          oMemoData = value.data.Memo.map((item, index) => ({ ...item, id: index }))
          delete value.data.Memo
          oJOData = { ...value.data }
          oJOData.processDrvId = null

          oJOData.Shipment = {
            CusNm: oJOData.CusNm,
            JobNo: oJOData.JobNo,
            Bkg: oJOData.Bkg,
            Agnt: oJOData.Agnt,
            Port: oJOData.Port,
            Vssl: oJOData.Vssl,
            Voy: oJOData.Voy,
            ShpmTypId: oJOData.ShpmTypId,
            Job: {
              RcptNm: oJOData.RcptNm,
              RcptAddr: oJOData.RcptAddr,
              RcptTaxId: oJOData.RcptTaxId,
              RcptBrchNo: oJOData.RcptBrchNo,
              Name: oJOData.JobNm,
              CmdyTyp: oJOData.CmdyTyp
            }
          }
          oJOData.ShRtnPOIId = oJOData.Shore?.RtnPOIId
          oJOData.ShRtnPlc = oJOData.Shore?.RtnPlc || ""
          oJOData.ShVssl = oJOData.Shore?.Vssl || ""
          oJOData.ShVoy = oJOData.Shore?.Voy || ""
          setContStsData(oContStatusData.map(item => ({ ...item })))
          prevContStsData = oContStatusData.map(item => ({ ...item }))
          setJOData({ ...oJOData })
          setMemoData(oMemoData.map((item) => ({ ...item })))
          setTagData(oTagData.map(item => ({ ...item })))
          setPTDataTable(addIdForDataGrid(value.data.PTs, "PCTrnsId"))
          setPIDataTable(addIdForDataGrid(value.data.PIs, "PCItmId"))
          setXJODataTable(addIdForDataGrid(value.data.XJOs, "ExpJobOrdId"))
          setFilesData(value.data.Files || [])
        }
      })
    } else {
      setTagData([])
      setJOData({ ...initPageData })
      setContStsData(msData.containerStatuses.map(item => ({ ...item })))
      setFilesData([])
      setPTDataTable([])
      setPIDataTable([])
      setXJODataTable([])
      setMemoData([])
      prevContStsData = []
      oContStatusData = []
    }
  }, [dialogOpen, selectedId, ax, msData.containerStatuses])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth
      PaperProps={{
        style: {
          maxWidth: 1800
        }
      }}
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={`ข้อมูลใบงานเลขที่ ${selectedId}`}
        onDeleteClick={() => deleteJobOrder(selectedId)}>
        <Box display="flex" gap={2} ml={2}>
          {!joData.PrId &&
            <Button variant="contained" color="secondary" onClick={() => window.open(`${window.location.origin}/emily/AddJobOrderChild/${selectedId}`, "_blank")}>เพิ่ม/พิมพ์ใบงานย่อย</Button>
          }
          <ButtonGroupPopper mainButton={
            <Button variant="contained" color="secondary"
              onClick={handlePrintJobOrder} >
              พิมพ์ซ้ำใบงาน
            </Button>
          }
            arrowButtonStyle={{ variant: "contained", color: "secondary" }}>
            <Paper >
              <Button variant="outlined" size="small" color="secondary" onClick={handlePrintJobOrderWithBg}>พิมพ์พร้อมพื้นหลัง</Button>
            </Paper>
          </ButtonGroupPopper>
        </Box>
      </DialogHeader>
      <DialogContent sx={{ bgcolor: blueGrey[50], p: 1, height: 905 }}>
        <BoxFR pt={1} sx={{ alignItems: "stretch", height: "100%" }}>
          <BoxFC sx={{ gap: 1, height: "100%", width: 520 }}>
            <Paper sx={{ pt: 1, pb: 1, width: "100%", height: 130 }}>
              <BoxFR ml={2}>
                <Typography variant="h6">สถานะตู้</Typography>
              </BoxFR>
              <ContStatus contStatusData={contStatusData} joData={joData} />
            </Paper>

            <Paper sx={{ px: 2, pt: 1, pb: 2, width: "100%" }}>
              <BoxFC sx={{ gap: 1 }}>
                <Typography variant="h6" sx={{ width: "100%" }}>ข้อมูลใบแจ้งลาก</Typography>
                <Shipment joData={joData} msData={msData} />
              </BoxFC>
            </Paper>
            <Paper sx={{ px: 2, pt: 1, pb: 2, width: "100%", }}>
              <BoxFC sx={{ gap: 1 }}>
                <Typography variant="h6" sx={{ width: "100%" }}>ข้อมูลชอร์</Typography>
                <Shore joData={joData} msData={msData} />
              </BoxFC>
            </Paper>
            <Paper sx={{ p: 1, width: "100%" }}>
              <BoxFC sx={{ gap: 1 }} height={340} >
                <Memo memoData={memoData} setMemoData={setMemoData} dialogOpen={dialogOpen} msData={msData} />
              </BoxFC>
            </Paper>
          </BoxFC>
          <BoxFC sx={{ gap: 1 }}>
            <Paper sx={{ px: 2, pt: 1, flex: 1 }}>
              <BoxFC sx={{ gap: 1, height: "100%" }}>

                <JODataComponent
                  joData={joData}
                  setJOData={setJOData}
                  contStatusData={contStatusData}
                />
                <ContStsComponent
                  contStatusData={contStatusData}
                  setContStsData={setContStsData}
                  joData={joData}
                  setJOData={setJOData} />
                <BoxFR sx={{ alignItems: "stretch", flex: 1 }}>

                  <JODataExtraComponent joData={joData} setJOData={setJOData} tagData={tagData} setTagData={setTagData} />
                  <PCComponent
                    joData={joData}
                    setJoData={setJOData}
                    ptDataTable={ptDataTable}
                    setPTDataTable={setPTDataTable}
                    piDataTable={piDataTable}
                    onPettyCashFinish={onPettyCashFinish} />
                  <XJOComponent
                    xjoDataTable={xjoDataTable}
                    onPettyCashFinish={onPettyCashFinish}
                    jobOrdId={joData.JobOrdId} />
                </BoxFR>


              </BoxFC>
            </Paper>
            <Paper sx={{ px: 2, pt: 1, height: 170, maxWidth: 1260 }}>
              <FilePreviewComponent
                filesData={filesData}
                jobOrdId={joData.JobOrdId}
                joData={joData}
                onPettyCashDialogFinish={onPettyCashFinish} />
            </Paper>
          </BoxFC>

        </BoxFR >
      </DialogContent >
      <DialogFooter okText="แก้ไขข้อมูล"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOK} />
    </Dialog >

  );
}

export default DailyJobDialogV3;
